import React from 'react';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

const style = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 5,
    cursor: 'pointer',
  },
  icon: {
    fontSize: 12,
    lineHeight: '12px',
    color: '#bfbfbf',
    position: 'relative',
  },
  up: {
    top: 4,
  },
  down: {
    top: -2,
  },
  activeIcon: {
    color: '#1890ff',
  },
};

const getSortValue = (function* getSortValue() {
  while (true) {
    yield 'ASC';
    yield 'DESC';
    yield null;
  }
})();

const Sort = ({ onSort, index, sort }) => {
  const onSortClick = () => {
    const sort = getSortValue.next().value;
    onSort(index, sort);
  };

  const getStyle = key =>
    sort.key === index && sort.order === key
      ? { ...style.icon, ...style.activeIcon }
      : style.icon;

  return (
    <div style={style.container} onClick={onSortClick} role="button">
      <Icon type="caret-up" style={{ ...getStyle('ASC'), ...style.up }} />
      <Icon type="caret-down" style={{ ...getStyle('DESC'), ...style.down }} />
    </div>
  );
};

Sort.propTypes = {
  onSort: PropTypes.func.isRequired,
  index: PropTypes.string.isRequired,
  sort: PropTypes.shape({
    key: PropTypes.string,
    order: PropTypes.string,
  }).isRequired,
};

export default Sort;
